import Footer from "@components/Footer/index";
import { NavBar } from "@components/NavBar";
import { PageLoader } from "@features/common/ui/PageLoader";
import { Failure } from "@features/Failure";
import { useQueryAppConfiguration } from "@hooks/appConfiguration/useQueryAppConfiguration";
import { useQueryCart } from "@hooks/cart";
import { useQueryGetUserByKeycloakId } from "@hooks/user/useQueryGetUserByKeycloakId";
import { SELECTED_PROJECT } from "./configuration";
import { RoutesConfig } from "./RoutesConfig";

function App() {
  const { userId } = useQueryGetUserByKeycloakId();

  useQueryCart({ userId });
  const { isLoading, isError } = useQueryAppConfiguration();

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError) {
    return <Failure />;
  }

  return (
    <>
      <NavBar />
      <RoutesConfig />
      <Footer />
    </>
  );
}

export default App;
